import * as types from '@/store/types'
import axios from 'axios'
import constConf from '../../../constconf'
export default {
    loadAlbumItems: (context, payload) => {
        return context.dispatch('api/queryVk', payload, { root: true }).then(response => {
            console.log(response)
            if (response.type === 'QueryResult') {
                context.commit('loadAlbumItems', response.response.data.response.items)
            } else {
                context.commit('loadAlbumItems', [])
            }
            return response
        })
    },
    sendChanges: (context, payload) => {
        payload.url = constConf.tool.url + '/market-vk/replace'
        payload.method = 'POST'
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                console.log(response)
                if (response.type === 'QueryResult') {
                    context.commit('loadAlbumItems', response.response.data.response.items)
                } else {
                    context.commit('loadAlbumItems', [])
                }
                return response
            })
    },
    uploadImage: (context, {botId, payload}) => {
        let formData = new FormData()
        formData.append('image', payload)

        return axios.post(constConf.tool.url + '/upload/image/' + botId, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then(response => {
                return response.data
            })
            .catch(error => {
                console.error(error.response)
            })
    }
}
